import { Navigate } from 'react-router-dom';

const Search = () => <Navigate to="/" replace />;

export default Search;
